import api from '../config/api';

export interface Comment {
  id: number;
  utilisateur: {
    id: number;
    username: string;
    first_name: string;
    last_name: string;
    photo?: string;
  };
  contenu: string;
  created_at: string;
}

export interface RamadanExpose {
  id: number;
  nom_exposant: string;
  prenom_exposant: string;
  telephone_exposant: string;
  classe: string;
  photo_exposant?: string;
  theme: string;
  description?: string;
  date_expose: string;
  jour_ramadan?: number;
  mini_video?: string;
  lien_youtube?: string;
  lien_tiktok?: string;
  lien_instagram?: string;
  audio_complet?: string;
  fichier_pdf?: string;
  status: string;
  status_auto?: string; // Statut calculé automatiquement
  section: 'VCN' | 'HDR' | 'SANTE';
  url_slug: string;
  annee_ramadan: number;
  nombre_vues: number;
  nombre_likes: number;
  nombre_commentaires: number;
  is_liked: boolean;
  commentaires_approuves?: Comment[];
  created_at: string;
}

export interface RamadanFilters {
  status?: string;
  section?: 'VCN' | 'HDR' | 'SANTE' | '';
  annee_ramadan?: number;
  ordering?: string;
  page?: number;
  page_size?: number;
  search?: string;
}

export const ramadanService = {
  getAll: async (filters?: RamadanFilters): Promise<{ results: RamadanExpose[]; count?: number; next?: string; previous?: string }> => {
    const response = await api.get('/ramadan/exposes/', { params: filters });
    return response.data;
  },

  getById: async (idOrSlug: number | string): Promise<RamadanExpose> => {
    // idOrSlug peut être un ID numérique ou un url_slug (prénom-nom-id)
    const response = await api.get(`/ramadan/exposes/${idOrSlug}/`);
    return response.data;
  },

  like: async (idOrSlug: number | string): Promise<{ liked: boolean }> => {
    const response = await api.post(`/ramadan/exposes/${idOrSlug}/like/`);
    return response.data;
  },

  comment: async (idOrSlug: number | string, contenu: string): Promise<Comment> => {
    const response = await api.post(`/ramadan/exposes/${idOrSlug}/commenter/`, { contenu });
    return response.data;
  },

  // Modifier un commentaire
  updateComment: async (commentId: number, contenu: string): Promise<Comment> => {
    const response = await api.put(`/ramadan/commentaires/${commentId}/`, { contenu });
    return response.data;
  },

  // Supprimer un commentaire
  deleteComment: async (commentId: number): Promise<void> => {
    await api.delete(`/ramadan/commentaires/${commentId}/`);
  },

  // Incrémenter les vues
  incrementView: async (idOrSlug: number | string): Promise<void> => {
    await api.post(`/ramadan/exposes/${idOrSlug}/increment_view/`);
  },
};

